import * as services from '../services'

const fetchpackinstalledSauvegarde = function ({commit}) {
  // Call the packinstalled service on the server via websocket
  services.packinstalledService.find({
    query: {
      $sort: {
        id: 1
      }
    }
  }).then(packinstalled => {
    commit('FETCH_PACKINSTALLEDSAUVEGARDE', packinstalled.data /* .filter(p =>
      p.pack.Name === 'Sauvegarde sur serveur distant' ||
      p.pack.Name === 'Sauvegarde locale'
    ) */)
  })
}

const fetchservicemonitoring = function ({commit}) {
  // Call the servicemonitoring service on the server via websocket
  services.servicemonitoringService.find({
    query: {
      $sort: {
        id: 1
      }
    }
  }).then(servicemonitoring => {
    commit('FETCH_SERVICEMONITORING', servicemonitoring.data)
  })
}

const setAdminStatus = function ({commit}, status) {
  commit('SET_ADMINSTATUS', status)
}

const setUserId = function ({commit}, userId) {
  commit('SET_USERID', userId)
}

const setUserName = function ({commit}, userName) {
  commit('SET_USERNAME', userName)
}

export default {
  fetchpackinstalledSauvegarde,
  fetchservicemonitoring,
  setAdminStatus,
  setUserId,
  setUserName
}



// WEBPACK FOOTER //
// ./src/store/actions.js